// Load PayPal as module (not script tag)
import {
    loadScript, OnApproveActions, OnApproveData, PayPalScriptOptions,
    // PayPalCardFieldsComponentOptions, CardFieldsOnApproveData, PayPalCardFieldsComponent, // For PayPal Expanded
    // OnCancelledActions, // For PayPal Expanded (?)
} from "@paypal/paypal-js";
import { ReportErrorToServer } from "../Lib/ReportErrorToServer";
import { AppSettings } from "../Lib/BTCTypes";
import { PageBusyIndicator } from "../Lib/PageBusyIndicator";

// Note: If uBlock Origin is turned on, console will show error:
// "Cross-Origin Request Blocked: The Same Origin Policy disallows reading the remote resource at https://www.sandbox.paypal.com/xoplatform/logger/api/logger?disableSetCookie=true. (Reason: CORS request did not succeed)"

export function PayPalWrapperInit(PayPalClientId: string) {
    new PayPalWrapper(PayPalClientId);
}

class PayPalWrapper {
    private static pageBusyIndicator: PageBusyIndicator;

    constructor(protected PayPalClientId: string) {
        PayPalWrapper.pageBusyIndicator = new PageBusyIndicator("idTSSpinner");
        this.DoLoadPayPal();
    }

    private static fundingSource: any;
    //private cardField: PayPalCardFieldsComponent | null = null; // For PayPal Expanded

    private async DoLoadPayPal(): Promise<void> {
        PayPalWrapper.pageBusyIndicator.Increment();

        let ppOptions: PayPalScriptOptions = {
            clientId: this.PayPalClientId,
            components: ["buttons", "applepay"], // ApplePay only shows on iPhones?
            //enableFunding: ["venmo"], // Required to allow Venmo
            //disableFunding: ["card"], // User enters card info directly into cart screen via PayPal rendered form
            dataPageType: "checkout",
            //debug: (MyPayPal.DevMode() ? "true" : "false"),
            //buyerCountry: "US" // Needed for Venmo testing: https://developer.paypal.com/docs/checkout/pay-with-venmo/test/
            //environment: "sandbox"
        };

        let paypal = await loadScript(ppOptions)
        if (paypal) {
            try {
                if (paypal.Buttons) {
                    let ppButtons = paypal.Buttons({
                        onClick: (data) => {
                            PayPalWrapper.fundingSource = data.fundingSource; // Remember which PayPal payment button user clicked
                        },
                        createOrder: this.MyCreateOrder,
                        onApprove: this.MyOnApprove,
                        // onError: this.MyOnError,
                        // onCancel: this.MyOnCancel
                    });
                    await ppButtons.render("#paypal-button-container");
                }

                // // For PayPal Expanded
                // // Render each field after checking for eligibility
                // // Note: To activate CardFields, in "PayPal Developer Dashboard", under "Apps and Credentials",
                // // under "BTCWeb" app, under "Features", under "Accept Payments", click "Advanced Credit and Debit Card Payments",
                // // then wait 24 hours. Must be done in both Sandbox and Live environments. Optionally, allow Apple Pay and
                // // Google Pay.
                // // Also need BTC to be approved for PayPay Expanded
                // if (paypal.CardFields) {
                //     const p2: PayPalCardFieldsComponentOptions = {
                //         createOrder: this.MyCreateOrder,
                //         onApprove: this.MyOnApproveExpanded,
                //         style: {
                //             input: {
                //                 "font-size": "16px",
                //                 "font-family": "courier, monospace",
                //                 "font-weight": "lighter",
                //                 color: "#ccc",
                //             },
                //             ".invalid": { color: "purple" },
                //         },
                //         onError: this.onErrorExpanded
                //     };
                //     this.cardField = paypal.CardFields(p2);

                //     if (this.cardField.isEligible()) {
                //         const nameField = this.cardField.NameField({
                //             style: { input: { color: "blue" }, ".invalid": { color: "purple" } },
                //         });
                //         nameField.render("#card-name-field-container");

                //         const numberField = this.cardField.NumberField({
                //             style: { input: { color: "blue" } },
                //         });
                //         numberField.render("#card-number-field-container");

                //         const cvvField = this.cardField.CVVField({
                //             style: { input: { color: "blue" } },
                //         });
                //         cvvField.render("#card-cvv-field-container");

                //         const expiryField = this.cardField.ExpiryField({
                //             style: { input: { color: "blue" } },
                //         });
                //         expiryField.render("#card-expiry-field-container");


                //         // Add click listener to submit button and call the submit function on the CardField component
                //         const but = (document.getElementById("card-field-submit-button") as HTMLButtonElement);
                //         but.addEventListener("click", () => {
                //             if (this.cardField) {
                //                 const ba = {
                //                     // From your billing address fields
                //                     billingAddress: {
                //                         addressLine1: (document.getElementById("card-billing-address-line-1") as HTMLInputElement).value,
                //                         addressLine2: (document.getElementById("card-billing-address-line-2") as HTMLInputElement).value,
                //                         adminArea1: (document.getElementById("card-billing-address-admin-area-line-1") as HTMLInputElement).value,
                //                         adminArea2: (document.getElementById("card-billing-address-admin-area-line-2") as HTMLInputElement).value,
                //                         countryCode: (document.getElementById("card-billing-address-country-code") as HTMLInputElement).value,
                //                         postalCode: (document.getElementById("card-billing-address-postal-code") as HTMLInputElement).value,
                //                     },
                //                 };
                //                 this.cardField
                //                     .submit()
                //                     .then(() => {
                //                         // submit successful
                //                     });
                //             }
                //         });
                //     }
                // }
            }
            catch (error) {
                const ErrMsg = "Failed to load the PayPal JS SDK script";
                console.error(ErrMsg, error);
                await ReportErrorToServer.ReportClientErrorToServer(ErrMsg, "DoLoadPayPal()", error);
            };
        }
        else {
            const ErrMsg = "PayPal object is null";
            console.error(ErrMsg);
            await ReportErrorToServer.ReportClientErrorToServer(ErrMsg, "DoLoadPayPal()");
        }

        PayPalWrapper.pageBusyIndicator.Decrement();
    }

    // // For PayPal Expanded
    // private async onErrorExpanded(err: Record<string, unknown>): Promise<void> {
    //     console.log(err.toString());
    //     await ReportErrorToServer.ReportClientErrorToServer(err.toString(), "onError()");
    // }

    // // For PayPal Expanded
    // private async MyOnApproveExpanded(data: CardFieldsOnApproveData): Promise<void> {

    // }


    private async MyCreateOrder(): Promise<string> { // In BTC checkout page, user has clicked PayPal payment button
        PayPalWrapper.pageBusyIndicator.Increment();
        let OrderId: string = "";
        const URL = AppSettings.BTCAPIAddress() + "/BTCAPI/PayPalCheckout/CreateOrder";
        const HttpVerb = "POST";
        await fetch(URL, { method: HttpVerb })
        .then(async (response: Response) => {
            if (response.ok) { // Server returned success code in 200 range
                const jsonOrder = await response.json();
                OrderId = jsonOrder.id;
            }
            else {
                let ErrMsg = "";
                ErrMsg += "Status: " + response.status + "<br>\n";
                ErrMsg += "Type: " + response.type + "<br>\n";
                ErrMsg += "Content-Type Header: " + response.headers.get("content-type") + "<br>";
                let jsonOrder = "";
                if (response.bodyUsed)
                    jsonOrder = await response.json();
                ErrMsg += "Body as json: " + jsonOrder.toString() + "<br>\n";
                await ReportErrorToServer.DisplayAndProcessAjaxFailure2(URL, HttpVerb, response.status, null, ErrMsg);
            }
        }
        ).catch(async (error: Error) => {
            await ReportErrorToServer.DisplayAndProcessAjaxFailure2(URL, HttpVerb, -1, null, "", error);
        })
        .finally(() => {
            PayPalWrapper.pageBusyIndicator.Decrement();
        });

        return OrderId;
    }

    // On PayPal, user has approved the payment
    private async MyOnApprove(data: OnApproveData, actions: OnApproveActions): Promise<void> {
        PayPalWrapper.pageBusyIndicator.Increment();

        const URL = AppSettings.BTCAPIAddress() + `/BTCAPI/PayPalCheckout/orders/${data.orderID}/capture`;
        const HttpVerb = "POST";
        await fetch(URL, { method: HttpVerb, credentials: "include" }) // Include credentials so server can get MemberId if user is signed-in
        .then(async (response: Response) => {
            // Three cases to handle:
            //   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
            //   (2) Other non-recoverable errors -> Show a failure message
            //   (3) Successful transaction -> Show confirmation or thank you message

            if (response.ok) { // Server returned success code in 200 range
                const jsonOrder = await response.json();

                const errorDetail = jsonOrder?.details?.[0];

                if (errorDetail?.issue === "INSTRUMENT_DECLINED") {
                    // (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
                    // recoverable state
                    return actions.restart();
                } else if (errorDetail) { // (2) Other non-recoverable errors -> Show a failure message
                    const ErrMsg = `${errorDetail.description} (${jsonOrder?.debug_id})`;
                    (document.getElementById("ErrorMessage") as HTMLDivElement).innerHTML = ErrMsg;
                    await ReportErrorToServer.ReportClientErrorToServer(ErrMsg, "MyOnApprove()");
                    throw new Error(ErrMsg);
                } else if (!jsonOrder.purchaseUnits) {
                    let ErrMsg = "purchanceUnits is missing. " + JSON.stringify(jsonOrder);
                    (document.getElementById("ErrorMessage") as HTMLDivElement).innerHTML = ErrMsg;
                    await ReportErrorToServer.ReportClientErrorToServer(ErrMsg, "MyOnApprove()");
                    throw new Error(ErrMsg);
                } else {
                    // (3) Successful transaction
                    // const transaction =
                    //     orderData?.purchaseUnits?.[0]?.payments?.captures?.[0] ||
                    //     orderData?.purchaseUnits?.[0]?.payments?.authorizations?.[0];

                    // Uncomment this for debugging
                    //console.log("Capture result", orderData, JSON.stringify(orderData, null, 2));

                    let FundingSourceDesc: string;
                    switch (PayPalWrapper.fundingSource) {
                        case "paypal": FundingSourceDesc = "PayPal"; break;
                        case "card": FundingSourceDesc = "PayPal using credit/debit card"; break;
                        case "venmo": FundingSourceDesc = "Venmo"; break;
                        default: FundingSourceDesc = PayPalWrapper.fundingSource; break;
                    }

                    (document.getElementById("ErrorMessage") as HTMLDivElement).innerText = "";

                    (document.getElementById("tblCart") as HTMLTableElement).style.display = "none"; // Hide cart section
                    (document.getElementById("divPaymentGatewayButtons") as HTMLDivElement).style.display = "none"; // Hide PayPal buttons section

                    let textFundingSource = document.getElementById("FundingSource") as HTMLInputElement;
                    textFundingSource.value = FundingSourceDesc;
                    textFundingSource.dispatchEvent(new Event('change', { 'bubbles': true })); // Tell Blazor DOM has changed

                    // Setting the PayerEmailAddress tells Blazor that payment is complete
                    let textPayerEmailAddress = document.getElementById("PayerEmailAddress") as HTMLInputElement;
                    textPayerEmailAddress.value = jsonOrder?.payer?.emailAddress;
                    textPayerEmailAddress.dispatchEvent(new Event('change', { 'bubbles': true })); // Tell Blazor DOM has changed
                }
            }
            else {
                let ErrMsg = "";
                ErrMsg += "Status: " + response.status + "<br>\n";
                ErrMsg += "Type: " + response.type + "<br>\n";
                ErrMsg += "Content-Type Header: " + response.headers.get("content-type") + "<br>";
                let jsonOrder = "";
                if (response.bodyUsed)
                    jsonOrder = await response.json();
                ErrMsg += "Body as json: " + jsonOrder.toString() + "<br>\n";
                await ReportErrorToServer.DisplayAndProcessAjaxFailure2(URL, HttpVerb, response.status, null, ErrMsg);
            }
        }
        ).catch(async (error: Error) => { // Note: Unlike .fail(), .catch() will stop the exception from bubbling up
            await ReportErrorToServer.DisplayAndProcessAjaxFailure2(URL, HttpVerb, -1, null, "", error);
        }).finally(() => {
            PayPalWrapper.pageBusyIndicator.Decrement();
        });
    }
}
